(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8986],{

/***/ 80998:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/home/[[...slug]]",
      function () {
        return __webpack_require__(85752);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 85752:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Index; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var _mosanic_core_Page_Render__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26381);



var __N_SSG = true;
function Index(param) {
    var data = param.data, collection = param.collection, entry = param.entry, page = param.page, header = param.header, footer = param.footer;
    header = header ? JSON.parse(header) : null;
    footer = footer ? JSON.parse(footer) : null;
    page = page ? JSON.parse(page) : null;
    data = data ? JSON.parse(data) : null;
    collection = collection ? JSON.parse(collection) : null;
    entry = entry ? JSON.parse(entry) : null;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mosanic_core_Page_Render__WEBPACK_IMPORTED_MODULE_1__/* .PageRender */ .XP, {
        page: page,
        seo: page === null || page === void 0 ? void 0 : page.seo,
        entry: entry,
        headerPage: header,
        footerPage: footer,
        site: data
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(80998); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);